import { Menu } from "@mantine/core";
import { ModalComponent } from "components";
import { DeleteMenuItemProps } from "./types";

import { useTableProvider } from "../../providers";
import { useModals } from "@mantine/modals";

export function DeleteMenuItem(props: DeleteMenuItemProps) {
  const { serialNumber } = props;

  const modals = useModals();
  const { refreshTable } = useTableProvider();

  function handleClick() {
    modals.openContextModal("serial-number.delete", {
      title: <ModalComponent.Title>Are you sure?</ModalComponent.Title>,
      innerProps: {
        serialNumber: serialNumber,
        onSubmit: async () => await refreshTable(),
      },
    });
  }

  return <Menu.Item onClick={handleClick}>Delete</Menu.Item>;
}
